import Bugsnag from '@bugsnag/js'
import type { Environment } from 'typedefs/common/Environment'

import { ClientScenario } from '@cash-web/protos/squareup/franklin/api/client_scenario.pb'
import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'

export type OpenTaxRequest = {
  deep_link_url?: string
  tax_environment?: Environment
}
export type OpenTaxResponse = {
  flow_url: string
}
export const TAX_ONBOARDING_CONTEXT_PAYLOAD = 'CAI='

export const openTax = (data: OpenTaxRequest = {}, config?: CashRequestOptions) =>
  post<OpenTaxRequest, OpenTaxResponse>(`/cash-app/tax/1.0/open-tax`, data, {
    ...config,
    rejectOnError: true,
  })
// this will likely move later when there are more consumers
// for now will keep it where it's actually used.
export const getRedirectTo = () => {
  if (!window.encodedRedirectTo) {
    return null
  }

  try {
    return new URL(atob(window.encodedRedirectTo))
  } catch {
    Bugsnag.notify({ name: 'getRedirectTo', message: `App attempted to redirect to ${window.encodedRedirectTo}` })
  }

  return null
}

export const isTaxUpgradeScenario = (clientScenario?: ClientScenario) => {
  return clientScenario === ClientScenario.INITIATE_TAX_UPGRADE
}
export const getTaxFlowToken = async () => {
  const request: OpenTaxRequest = {}
  const deepLinkURL = getRedirectTo()

  if (deepLinkURL && hasTaxIntent()) {
    request.deep_link_url = deepLinkURL.href
    request.tax_environment = window.environment
  }

  const { flow_url } = await openTax(request)

  if (flow_url == null) {
    throw new Error('Failed to get flow token from tax front door')
  }

  return flow_url
}

export const hasTaxIntent = () => {
  return window.context === 'TAXES'
}
